/* eslint-disable */
import './../../vendors/datepicker.esm.js';
import './../../vendors/_/jquery.overlayScrollbars.js';
import '../../../css/OverlayScrollbars.css';

import './../../vendors/loader.js'; // chart loader
import { getParameterByName } from '../../app.js';
import { BindElements } from '../site-functions.js';
import loadMap  from '../advert/advert-gmap.js';
import carousel from '../../../../components/carousel/js/carousel.js';

//var sitemode = 'test';
var orgs;
var geocoder;
var map;
var defaultZoom = 25;
var localZoom = 8;
var worldZoom = 1;
// This is the minimum zoom level that we'll allow
var minZoomLevel = 1;
var singleItemZoom = 15;
var mapCenter = new google.maps.LatLng(53.764288, -1.856801);
//var mapCenterPanel = new google.maps.LatLng(55.25, 3.06);
//var mapCenterWorld = new google.maps.LatLng(0, 0);
var bounds = new google.maps.LatLngBounds();
var originMarker;
var markersArray = [];
var markerCluster;
var mapResized = false;
var myLatLng;
var loaderSmall = '<img src="/dist/images/ajax-loader.gif" />';



var advertLimit = 250;
//var advertCountWarning = "Sorry. There are too many adverts to display. Please try refining your requirements.\n\nThe maximum number we can show is " + advertLimit + ". ";
var advertCountWarning = '<h1>Oops...sorry</h1>';
advertCountWarning += '<p>';
advertCountWarning += 'There are a lot of adverts to display, so might be a little slow.<br />';
advertCountWarning += 'Please try refining your requirements.';
advertCountWarning += '</p>';
//advertCountWarning += '<p>The maximum number we can show is ' + advertLimit + '.</p>';

var minBedrooms, maxBedrooms, minRent, maxRent, bedsList;
var priceGraphData = '';

var chartData;
var graphOptions = {
  areaOpacity: 1,
  axisTitlesPosition: 'none',
  backgroundColor: '#fff',
  chartArea: {
    backgroundColor: '#fff',
    height: 60,
    left: 10,
    top: 10,
    width: '100%'
  },
  colors: ['#a1cc99'],
  connectSteps: false,
  crosshair: {
    color: '#449a34',
    orientation: 'vertical',
    trigger: 'focus'
  },
  focusTarget: 'category',
  hAxis: null,
  height: 70,
  legend: { position: 'none' },
  tooltip: {
    isHtml: true,
    showColorCode: false
  },
  //enableInteractivity: false,
  vAxis: {
    gridlines: {
      count: 0
    },
    baselineColor: '#a1cc99'
  }
};

var graphOptionsSmall = {
  areaOpacity: 1,
  axisTitlesPosition: 'none',
  backgroundColor: '#fff',
  chartArea: {
    backgroundColor: '#fff',
    height: 30,
    left: 10,
    top: 5,
    width: '100%'
  },
  colors: ['#a1cc99'],
  connectSteps: false,
  crosshair: {
    color: '#449a34',
    orientation: 'vertical',
    trigger: 'focus'
  },
  focusTarget: 'category',
  hAxis: null,
  height: 40,
  legend: { position: 'none' },
  tooltip: {
    isHtml: true,
    showColorCode: false
  },
  //enableInteractivity: false,
  vAxis: {
    gridlines: {
      count: 0
    },
    baselineColor: '#a1cc99'
  }
};

var filterSelections = {
  propertyType: 0,
  wholeProperty: 3,
  bedsFrom: 1,
  dateMode: 2
};



//$.ajaxStart(function () {
//    showLoading();
//});
//$.ajaxComplete(function () {
//    hideLoading();
//});


function showLoading() {
  $(".loader").addClass('show');
}

function hideLoading() {
  $(".loader").removeClass('show');
}


var clusterStyles = [
  {
    textColor: '#4b4845',
    textSize: '12',
    url: '/dist/images/cluster-68-67.png',
    height: 67,
    width: 68
  },
  {
    textColor: '#4b4845',
    textSize: '14',
    url: '/dist/images/30_04.png',
    height: 40,
    width: 40
  },
  {
    textColor: '#4b4845',
    textSize: '16',
    url: '/dist/images/30_05.png',
    height: 50,
    width: 50
  }
];

var propertiesList = [];
var propertiesListFiltered = [];
var propertiesListFavourites = [];

var poiList = [];
var advertMarkers = new Object();
var advertFilter = new Object();
var advertMarkersFavourites = new Object();
var poiMarkers = new Object();

var imagePinLarge = new google.maps.MarkerImage('/dist/images/noncode-dev.png',
  // This marker is 129 pixels wide by 42 pixels tall.
  null, //new google.maps.Size(80, 81),
  // The origin for this image is 0,0.
  null, //new google.maps.Point(0, 0),
  // The anchor for this image is the base of the flagpole at 18,42.
  null, //new google.maps.Point(39, 78),
  new google.maps.Size(60, 80)
);

// Define Marker properties
var imagePinCodeLarge = new google.maps.MarkerImage('/dist/images/code-dev.png',
  // This marker is 129 pixels wide by 42 pixels tall.
  null, //new google.maps.Size(80, 81),
  // The origin for this image is 0,0.
  null, //new google.maps.Point(0, 0),
  // The anchor for this image is the base of the flagpole at 18,42.
  null, //new google.maps.Point(39, 78),
  new google.maps.Size(60, 80)
);

// Define Marker properties
var imagePinCodeLargeUnipol = new google.maps.MarkerImage('/dist/images/pin-unipol-dev.png',
  // This marker is 129 pixels wide by 42 pixels tall.
  null, //new google.maps.Size(80, 81),
  // The origin for this image is 0,0.
  null, //new google.maps.Point(0, 0),
  // The anchor for this image is the base of the flagpole at 18,42.
  null, //new google.maps.Point(39, 78),
  new google.maps.Size(60, 80)
);

// Define Marker properties
var imagePinCodeUnipol = new google.maps.MarkerImage('/dist/images/pin-unipol.png',
  // This marker is 129 pixels wide by 42 pixels tall.
  null, //new google.maps.Size(80, 81),
  // The origin for this image is 0,0.
  null, //new google.maps.Point(0, 0),
  // The anchor for this image is the base of the flagpole at 18,42.
  null, //new google.maps.Point(39, 78),
  new google.maps.Size(60, 80)
);

// Define Marker properties
var imagePinCode = new google.maps.MarkerImage('/dist/images/code.png',
  // This marker is 129 pixels wide by 42 pixels tall.
  null, //new google.maps.Size(80, 81),
  // The origin for this image is 0,0.
  null, //new google.maps.Point(0, 0),
  // The anchor for this image is the base of the flagpole at 18,42.
  null, //new google.maps.Point(39, 78),
  new google.maps.Size(60, 80)
);

var imagePinStandard = new google.maps.MarkerImage('/dist/images/noncode.png',
  // This marker is 129 pixels wide by 42 pixels tall.
  null, //new google.maps.Size(80, 81),
  // The origin for this image is 0,0.
  null, //new google.maps.Point(0, 0),
  // The anchor for this image is the base of the flagpole at 18,42.
  null, //new google.maps.Point(39, 78),
  new google.maps.Size(60, 80)
);

var markerIconPOI = new google.maps.MarkerImage('/dist/images/pin-poi.png',
  // This marker is 129 pixels wide by 42 pixels tall.
  null, //new google.maps.Size(80, 81),
  // The origin for this image is 0,0.
  null, //new google.maps.Point(0, 0),
  // The anchor for this image is the base of the flagpole at 18,42.
  null, //new google.maps.Point(39, 78),
  new google.maps.Size(32, 35)
);

var mcOptions = { gridSize: 30, maxZoom: 12, styles: clusterStyles };
var infowindow = new google.maps.InfoWindow();


var showlocal = true;
var searchLatLng = '';
var worldQParam = '';
var keywordQParam = '';
var locationQParam = '';

var sliderBedrooms;
var sliderRent;
var currentCity;


// Add in filter support for older browsers
if (!Array.prototype.filter) {
  Array.prototype.filter = function (fun /*, thisp */) {
    "use strict";

    if (this === null)
      throw new TypeError();

    var t = Object(this);
    var len = t.length >>> 0;
    if (typeof fun !== "function")
      throw new TypeError();

    var res = [];
    var thisp = arguments[1];
    for (var i = 0; i < len; i++) {
      if (i in t) {
        var val = t[i]; // in case fun mutates this
        if (fun.call(thisp, val, i, t))
          res.push(val);
      }
    }

    return res;
  };
}


window.hideFlashingCursor = function () {
  $(".monthpicker").blur();
};


//var a;
$(window).resize(function () {
  if ('styleMedia' in window && window.styleMedia.matchMedium("only screen and (max-width: 480px)")) {
    {
      $(".map-container").addClass("mobile");
    }
  }
  if ('styleMedia' in window && window.styleMedia.matchMedium("only screen and (min-width : 640px) and (max-width: 1024px)")) {
    {
      $(".map-container").removeClass("mobile");
      $(".map-container").removeClass("top");
    }
  }
});


// Document Ready
$(function () {
    google.charts.load('current', { 'packages': ['corechart'] });


OverlayScrollbars(document.querySelector('.advert-list-panel'), {
    className: "os-theme-unipol"
  });

  currentCity = $('#City').val();

    if( $("#advert-filters").data('disable-filter-defaults').toString() === 'true') {
        filterSelections = {
            propertyType: $('#PropertyTypeId').val(),
            wholeProperty: $('#ddl-whole-property-required').val(),
            bedsFrom: $('#BedroomsFrom').val(),
            dateMode: $('#DateMode').val()
        };
    }

  // setting filters defaults received from the server
  var dateModeDefault = $("#advert-filters").data("date-mode");
  var wholePropertyRequiredDefault = $("#advert-filters").data("whole-property");

  if (dateModeDefault !== undefined && dateModeDefault !== "" && isFinite(dateModeDefault)) {
    filterSelections.dateMode = dateModeDefault;
  }

  if (wholePropertyRequiredDefault !== undefined && wholePropertyRequiredDefault !== "" && isFinite(wholePropertyRequiredDefault)) {
    filterSelections.wholeProperty = wholePropertyRequiredDefault;
  }

  //Get Filter UI Defaults
  setAffiliateUIdefaults(currentCity);

  //Check URL has
  checkUrlHash();

  //$('#DateMode').dropkick({
  //	change: function (value, label) {
  //		showMoveInDatePicker(value);
  //	}
  //});

  //$('#ddl-orderby').dropkick({
  //	change: function (value, label) {
  //		$('#OrderBy').val(value);
  //		setFiltersAndSubmit();
  //	}
  //});


  firstVisit();  //if first visit show intro tips

  showHousingHuntingWarning();  //show house hunting warning if the embargo is on

  BindElements();

  $('#filters-advanced').hide();

  // other code for the spinner here
  bindFilterPanel();


  $('#collapseOwners').collapse("hide");
  $('#collapseFacilities').collapse("hide");
  $('#collapseSuitability').collapse("hide");


  $(window).resize(function () {
    var heightDiff = 356;
    if ($(window).innerHeight() < 750) {
      heightDiff = 175;
    }
    $('#outer-wrap').height($(window).height());
    $('#inner-wrap').height($(window).height());
    $('.map-container').height($(window).height() - heightDiff);
  });

  $(window).trigger('resize');

  // Set last searched advert id if it exists in local storage
  var lastAdvertId = localStorage['lastAdvertId'];
  if (lastAdvertId !== '') {
    //$('#search-advert-id').val(lastAdvertId);
  }


  hideSaveSearchOption();

  hideLoading();

  if (TriggerSearch === "true") {

    SetupFilterUIControls();
    initializeMap();

    setTimeout(function () {
      if ($('#ShowEmbargoed').val() == "True") {
        setFiltersAndSubmit(false);
      }
      else {
        setFiltersAndSubmit(true);
      }
    }, 250);
  }

  $('#modal-virtual-tour').on('show.bs.modal', function (event) {
    // Get the button that triggered the modal
    var button = $(event.relatedTarget);

    // Extract value from the custom data-* attribute
    var titleData = button.data('title');
    var srcData = button.data('src');
    $(this).find('.modal-title span').text(titleData);
    $(this).find('.modal-body iframe').attr('src', srcData);
    $(this).find('.modal-body iframe').attr('data-caption', titleData);
  });
});


// ***** FUNCTIONS *********

function showMoveInDatePicker() {

  var $moveInDatePicker = $('#move-in-datepicker-container');

  var searchMode = $('#DateMode').val();

  if (searchMode === "4") {
    $moveInDatePicker.show();
    $('#DateMode').css("width", "50%");
  } else {
    $moveInDatePicker.hide();
    $('#DateMode').css("width", "");
  }
}


function checkUrlHash() {

  if (window.location.href.indexOf('#advert=') > -1 || window.location.href.indexOf('?advert=') > -1) {
    var advertId = window.location.hash.replace("#advert=", "");
    $('#search-advert-id').val(advertId);
    $('#btn-advert-by-id').trigger('click');
    return;
  }

  if (window.location.href.indexOf('#rentonline=') > -1 || window.location.href.indexOf('?rentonline=') > -1) {
    filterRentOnline();
    return;
  }

  ShowFilters();
}


function firstVisit() {
  $.get('/my-unipol/firstvisit', function (data) {
    if (data === "True") {
      showIntro();
    }
  });
}


function showIntro() {

  $('.tour').addClass('show');
  $('.grumble').show();
  $('.grumble-text').show();

  if (isSequenceComplete === false) return true;
  isSequenceComplete = false;

  $('#tour-list').grumble(
    {
      text: 'The properties that fit your search appear here. Select to view more info.',
      angle: 150,
      distance: 3,
      showAfter: 1500,
      hideAfter: false
    }
  );

  introFilter = $('#tour-filter').grumble(
    {
      text: 'Open the filter panel to help fine-tune your search',
      angle: 140,
      distance: 20,
      showAfter: 3500,
      hideAfter: false
    }
  );

  $('#tour-pin').grumble(
    {
      text: 'You can also select a pin for more info',
      angle: 50,
      distance: 10,
      showAfter: 5500,
      type: 'alt-',
      hideAfter: false
    }
  );

}


function setAffiliateUIdefaults(city, propertyType, bedrooms, wholeProperty, dateMode, moveInMonthYear, changedFilter) {

  var origPropertyType = propertyType;

  //showLoading();
  if (typeof propertyType === 'undefined' || !isFinite(propertyType) || propertyType === "") {
    propertyType = filterSelections.propertyType;
  }

  if (typeof bedrooms === 'undefined' || !isFinite(bedrooms) || bedrooms === "") {
    bedrooms = filterSelections.bedsFrom;
  }

  if (typeof wholeProperty === 'undefined' || !isFinite(wholeProperty) || wholeProperty === "") {
    wholeProperty = filterSelections.wholeProperty;
  }

  if (typeof dateMode === 'undefined' || !isFinite(dateMode) || dateMode === "") {
    dateMode = filterSelections.dateMode;
  }

  var showEmbargoed = $("#ShowEmbargoed").val();
  var isUnipolSearch = $("#IsUnipolSearch").val();
  if ((TriggerSearch === "true" && showEmbargoed == "true") || getParameterByName("showAllEmbargoedAdvertsThisYear") === "true") {
    showEmbargoed = true;
  }
  else if (isUnipolSearch) {
    showEmbargoed = true;
  }
  else {
    showEmbargoed = false;
  }

  if (propertyType === "10") {
    propertyType = "5";
  }

  if (city.length < 100) {

    if (window.innerWidth > 767) {
      $.ajax({
        url: '/accommodation/price-graph-simple/',
        data: {
          city: city,
          propertyType: propertyType,
          bedrooms: bedrooms,
          wholeProperty: wholeProperty,
          dateMode: dateMode,
          moveInMonthYear: moveInMonthYear,
          showEmbargoed: showEmbargoed
        },
        type: "Get",
        dataType: "json",
        success: function (data, status, XMLHttpRequest) {
            let result = 0;
            data.rows?.forEach(r => {
                result += r.c[2].v;
            });
            drawChart(data);
        },
        error: function (XMLHttpRequest, status, error) {
        }
      });
    }

    $.ajax({
      url: '/affiliatedatabycity/',
      data: {
        city: city,
        propertyType: propertyType,
        bedrooms: bedrooms,
        wholeProperty: wholeProperty,
        dateMode: dateMode,
        moveInMonthYear: moveInMonthYear,
        showEmbargoed: showEmbargoed
      },
      type: "Get",
      success: function (data, status, XMLHttpRequest) {

        // Show warning if no adverts for this choice
        if (data.filterOptions.advertCount === 0) {
          var msg = '<h1>Oops...sorry</h1>';
          msg += '<p>';
          msg += 'There are no adverts matching your choices.<br />';
          msg += 'Please try changing some of the initial 4 selections.';
          msg += '</p>';
          msg += '<p>(The "Whole Property Required" choice usually makes a big difference.)</p>';
          showMessageOverlay(msg);

          bindFilterPanel();
        }
        else {

          if (origPropertyType === "10") {

            // Shared House (3 beds or more) Rent Inclusive
            // Set inclusive filters
            $('#bills-inc-msg').html(" - We've set these options for you because you've selected a rent inclusive option under property type");

            if ($('#ApplyBillsInclusiveFilter').next('div').hasClass("on")) {
              //$('.js-bills-inclusive .unipol-style').removeClass('off').removeClass('on').addClass('on');
              $('.js-bills-inclusive .unipol-style-checkbox').prop("checked", true);
            }
            else {
              $('#ApplyBillsInclusiveFilter').next('div').trigger('click');
            }

            if ($('#accordionFilters .accordion-body').height() === 0) {
              $('#accordionFilters .accordion-toggle').trigger('click');
            }
            $('#ApplyBillsInclusiveFilter').next('div').prop('disabled', true);
            $('.js-bills-inclusive .unipol-style').prop('disabled', true);

          } else {

            $('#bills-inc-msg').html("");

            $('#ApplyBillsInclusiveFilter').next('div').prop('disabled', false);
            $('.js-bills-inclusive .unipol-style').prop('disabled', false);

          }


          minBedrooms = data.filterOptions.minBedrooms;
          maxBedrooms = data.filterOptions.maxBedrooms;

          if (TriggerSearch !== "true") {
            $("#RentFrom").val(data.filterOptions.minRent);
            $("#RentTo").val(data.filterOptions.maxRent);
            //minRent = data.filterOptions.MinRent;
            //maxRent = data.filterOptions.MaxRent;
          }

          minRent = $("#RentFrom").val();
          maxRent = $("#RentTo").val();


          bedsList = data.filterOptions.bedsList;

          // Bind the bedlist dropdown
          if (bedsList.length > 0) {
            var $select = $('#BedroomsFrom');
            var bedsFrom = $select.val();
            var bedsTo = $('#BedroomsTo').val();
            var selectedBeds = $select.val();

            //if (bedsFrom !== bedsTo) {
            //  selectedBeds = bedsTo;
            //}

            $select.find('option').remove();
            //$select.dropkick('refresh');

            bedsList.forEach(function (val) {
              var option = $('<option>').attr('value', val).html(val);
              if (val == selectedBeds) {
                option.attr('selected', 'selected');
              }
              $select.append(option);
            });

            //setTimeout(function (e) {
            //	$select.dropkick('refresh');
            //	$select.prevAll('.dk_toggle').css('width', '100%');
            //}, 100);
          }

          showChangedField('#dk_container_BedroomsFrom a.dk_toggle, .minRent, .maxRent');
          updateFilterSelections(false);
        }

        var affiliateLong = data.affiliate.long;
        var affiliateLat = data.affiliate.lat;
        var mapLongLat = new google.maps.LatLng(parseFloat(affiliateLat), parseFloat(affiliateLong));

        mapCenter = mapLongLat;

        SetupFilterUIControls();

        initializeMap();
        //hideLoading();
      },
      error: function (XMLHttpRequest, status, error) {
        minBedrooms = 1;
        maxBedrooms = 14;
        minRent = 0;
        maxRent = 200;

        SetupFilterUIControls();

        initializeMap();
      }
    });
  }

}


function SetupFilterUIControls() {
  //var city = $('#City').val();
  //var RentFrom = minRent; //$('#RentFrom').val();
  //var RentTo = maxRent; //$('#RentTo').val();
  //var BedroomsFrom = $('#BedroomsFrom').val();
  //var BedroomsTo = $('#BedroomsTo').val();

  //console.log($('#RentFrom').val());
  //console.log($('#RentTo').val());

  //console.log(minRent);
  //console.log(maxRent);

  //if (sliderRent != null) {
  //  return;
  //}

  //if (minRent == undefined)
  minRent = parseInt($('#RentFrom').val(), 10);

  //if (maxRent == undefined)
  maxRent = parseInt($('#RentTo').val(), 10);

  sliderRent = $("#sliderRent").slider({
    range: true,
    min: minRent,
    max: maxRent,
    step: 5,
    values: [minRent, maxRent],
    slide: function (event, ui) {

      //var $sliderRentFooter = $('#sliderRentFooter');

      var delay = function () {
        var handleIndex = $(ui.handle).index();

        if (handleIndex === 1) {
          //MinRent
          $('#minRent').html('£' + ui.value).position({
            my: 'center bottom',
            at: 'center top',
            of: ui.handle,
            offset: "0, 0"
          });
        } else {
          //MaxRent
          $('#maxRent').html('£' + ui.value).position({
            my: 'center top',
            at: 'center bottom',
            of: ui.handle,
            offset: "0, 10"
          });
        }
      };

      // wait for the ui.handle to set its position
      setTimeout(delay, 0);
    },
    stop: function (event, ui) {
        var delay = function () {
            var handleIndex = $(ui.handle).index();

            if (handleIndex === 1) {
                //MinRent
                let changedFilter = {
                    name: 'minRent',
                    value: '£' + ui.value
                }
            } else {
                //MaxRent
                let changedFilter = {
                    name: 'maxRent',
                    value: '£' + ui.value
                }
            }
        };

        setTimeout(delay, 0);
    }
  });

  $('#minRent').html('£' + minRent);
  //.position({
  //	my: 'center bottom',
  //	at: 'center top',
  //	of: $('#sliderRent a:eq(0)'),
  //	offset: "0, 100"
  //});

  $('#maxRent').html('£' + maxRent);
  //.position({
  //	my: 'center top',
  //	at: 'center bottom',
  //	of: $('#sliderRent a:eq(1)'),
  //	offset: "0, 10"
  //});

  var pricefilter = "PRICE: " + $('#minRent').text() + "-" + $('#maxRent').text() + " p/w";
  $('#price-filter').text(pricefilter);

  // setCurrentMonthYear();
  BindMonthPicker();
  setDefaultFilterValues();
}


function showHousingHuntingWarning() {
  if (TriggerSearch !== "true") {
    $.ajax({
      url: '/accommodation/show-warning/' + currentCity + '?showAllEmbargoedAdvertsThisYear=' + getParameterByName("showAllEmbargoedAdvertsThisYear"),
      type: "Get",
      success: function (data, status, XMLHttpRequest) {
        if (data.showMessage === true) {
          showWarningOverlay(data.messageText, data.messageImage);
        }
      },
      error: function (XMLHttpRequest, status, error) {
          if (error) {
              alert('An Error occurred: #1 ' + error);
          }
      }
    });
  }
}


function showEmbargoAdvertsMessage() {

  var currentCity = $('#City').val();
  if (TriggerSearch !== "true") {
    $.ajax({
      url: '/accommodation/show-embargo-warning/' + currentCity + '?showAllEmbargoedAdvertsThisYear=' + getParameterByName("showAllEmbargoedAdvertsThisYear"),
      type: "Post",
      data: getLatestAccommodationFilters(),
      success: function (data, status, XMLHttpRequest) {
        if (data.showMessage === true) {
          showMessageOverlay(data.messageText);
        }
      },
      error: function (XMLHttpRequest, status, error) {
          if (error) {
              alert('An Error occurred: #2 ' + error);
          }
      }
    });
  }
}


// Initialize the Google map
function initializeMap() {

  //alert(baseUrl);
  geocoder = new google.maps.Geocoder();
  var mapOptions = {
    zoom: defaultZoom,
    center: mapCenter,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    streetViewControl: false
  };
 // for accommodation page
  map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

  if (searchLatLng !== "" && searchLatLng !== "0") {
    originMarker = new google.maps.Marker({
      position: searchLatLng,
      map: map
    });

    // Wire up the infoWindow click handler
    google.maps.event.addListener(originMarker, 'click', (function (originMarker) {
      return function () {
        infowindow.setContent('<p><strong>Your search location<br />"' + locationQParam + '"</strong></p>');
        infowindow.open(map, originMarker);
      };
    })(originMarker));

    bounds.extend(searchLatLng);

    map.setZoom(localZoom);
    map.setCenter(searchLatLng);

  }

  //debugger;
  $.geolocation(function (lat, lng) {
    myLatLng = new google.maps.LatLng(lat, lng);
    var mymarker = new google.maps.Marker({
      position: myLatLng,
      //icon: markerIconPOI,
      animation: google.maps.Animation.DROP,
      map: map,
      title: "My Current Location"
    });
    // Wire up the infoWindow click handler
    google.maps.event.addListener(mymarker, 'click', (function (mymarker) {
      return function () {
        infowindow.setContent('<strong>My Current location</strong>');
        infowindow.open(map, mymarker);
      };
    })(mymarker));
    bounds.extend(myLatLng);
    map.setCenter(myLatLng);

    var $select = $("#PoiId");
    //$select.removeData("dropkick");
    //$("#dk_container_PoiId").remove();
    //$select.find('option[value=]').remove();
    $select.find('option[value="-1"]').remove();
    //$select.find('option[value=""]').remove();
    $select.prepend($('<option value="-1">My Current Location</option>'));
    //$select.prepend($('<option value="">I don\'t mind</option>'));
    //$('#dk_container_PoiId a.dk_toggle').attr('style', 'max-width: 198px !important');

    //if ($select.find('option[selected=selected]').length === 0) {
    //	$select.find('option[value=]').attr('selected', 'selected');
    //}

    //$select.dropkick('refresh');
    //$select.prevAll('.dk_toggle').css('max-width', '198px');
    //$select.prevAll('.dk_toggle').css('width', '198px');


    // update the hidden fields with the lat/long
    $('#MyLat').val(lat);
    $('#MyLong').val(lng);
  });


  // Limit the zoom level
  google.maps.event.addListener(map, 'zoom_changed', function () {
    if (map.getZoom() < minZoomLevel) map.setZoom(minZoomLevel);
  });
  google.maps.event.addListenerOnce(map, 'bounds_changed', function (event) {
    if (map.getZoom() > singleItemZoom) map.setZoom(singleItemZoom);
  });


  // Autocomplete
  var input = $('#location');

    if (input.length) {
    var options = {
      types: ['(cities)'],
      componentRestrictions: { country: 'gb' }
    };

    autocomplete = new google.maps.places.Autocomplete(input, options);
    autocomplete.bindTo('bounds', map);
  }


  //Load Points of interest
  loadPOIPins();
}

function setFiltersAndSubmit(triggerSearch) {

  if (triggerSearch === true) {
    var url = window.location.pathname;
    url = url.split("/");
    //alert(url[url.length - 1]);
    var formData = $('#advert-filters-form').serialize();

    searchBySearchId(formData);

  } else {
    $('#RentFrom').val(sliderRent.slider('values', 0));
    $('#RentTo').val(sliderRent.slider('values', 1));

    var pricefilter = "PRICE: " + $('#minRent').text() + "-" + $('#maxRent').text() + " p/w";
    $('#price-filter').text(pricefilter);

    var bedsFrom = $('#BedroomsFrom').val();
    var bedsTo = $('#BedroomsTo').val();
    var selectedBeds = bedsFrom;

    // if (bedsFrom !== bedsTo) {
    //   selectedBeds = bedsTo;
    // }

    var bedroomsfilter = "BEDROOMS: " + selectedBeds; // + " to " + bedsTo;

    $('#district-filter').text('DISTRICT: ' + $("#DistrictId option:selected").text());
    $('#bedrooms-filter').text(bedroomsfilter);

    //$('#movein-filter').text("MOVE IN: " + $('#MoveInMonthYear').val());
    // $('#movein-filter').text("MOVE IN: " + $('#ddl-move-in').find(":selected").text());

    $('#advert-filters-form').submit();
  }

  //Highlight Results Buttons
  $('#property-list-nav li').removeClass('active');
  $('#btn-results').parent('li').addClass('active');

  $('#search-advert-id').val();

  setMoveInFilterBarText();

}

function saveLatestAccommodationFilters(formDataToSave) {
  sessionStorage.setItem('latestSentFilters', formDataToSave);
}

function getLatestAccommodationFilters() {
  return sessionStorage.getItem('latestSentFilters') || '';
}

function setMoveInFilterBarText() {
  var moveInText = $('#DateMode').find(":selected").text();

  if ($('#DateMode').val() === "4") {
    moveInText = $('#MoveInMonthYear').val();

    showMoveInDatePicker();
  }

  $('#movein-filter').text("MOVE IN: " + moveInText);
}


function setDefaultFilterValues() {
  $('#sliderRent').slider('value', 0, $('#RentFrom').val());
  $('#sliderRent').slider('value', 1, $('#RentTo').val());
  setMoveInFilterBarText();
}


function setCurrentMonthYear() {

  $('#movein-filter').text("MOVE IN: " + $('#dk_container_DateMode').find(":selected").text());

}


function reloadAdvertPins() {

  propertiesList = [];
  deleteOverlays();

  var mapPin = advertMarkers;

  $.each(mapPin, function (i, item) {
    var object = item;
    var newProperty = new Object();
    newProperty.id = object.advertId;
    newProperty.advertType = object.advertType;
    newProperty.longLatOriginal = object.longLat;

    if (object.LongLat !== null) {
      //
      var latlngparts = object.longLat.split(",");
      var latlng = new google.maps.LatLng(parseFloat(latlngparts[0]), parseFloat(latlngparts[1]));

      newProperty.latlng = latlng;
      propertiesList.push(newProperty);
    }

  });

  placePins(propertiesList);

  hideLoading();

}


function loadPOIPins() {

  $.ajax({
    url: '/housing/poi',
    type: "Get",
    success: function (data, status, XMLHttpRequest) {
      let mapPinPOI = $.parseJSON(JSON.stringify(data));

      $.each(mapPinPOI, function (i, item) {
        var object = item;
        let newPOI = new Object();
        newPOI.id = object.ItemId;
        newPOI.name = object.Name;
        newPOI.latcoor = object.Lat;
        newPOI.longcoor = object.Long;

        if (object.Lat !== null) {
          var latlng = new google.maps.LatLng(parseFloat(newPOI.latcoor), parseFloat(newPOI.longcoor));
          newPOI.latlng = latlng;
          poiList.push(newPOI);
        }
      });

      //for (var i = 0; i < poiList.length; i++) {
      //	var marker = new google.maps.Marker({
      //		position: poiList[i].latlng,
      //		icon: markerIconPOI,
      //		map: map,
      //		title: poiList[i].name
      //	});
      //}

    },
    error: function (XMLHttpRequest, status, error) {
        if (error) {
            alert('An Error occurred: #3 ' + error);
        }
    }
  }, 1000);
}


function reloadAdvertPinsFavourites() {
  propertiesListFavourites = [];
  deleteOverlays();

  mapPin = $.parseJSON(advertMarkersFavourites);

  $.each(mapPin, function (i, item) {
    var object = item;
    newProperty = new Object();
    newProperty.id = object.PropertyHeaderId;
    newProperty.advertCount = object.AdvertCount;

    newProperty.advertType = object.AdvertType;
    if (object.LongLat !== null) {
      var latlngparts = object.LongLat.split(",");
      var latlng = new google.maps.LatLng(parseFloat(latlngparts[0]), parseFloat(latlngparts[1]));

      newProperty.latlng = latlng;
      propertiesListFavourites.push(newProperty);
    }


  });
  placePins(propertiesListFavourites);

  hideLoading();
}


function placePins(locations) {
  for (var i = 0; i < locations.length; i++) {
    addMarker(locations[i], i);
  }
  // populate the Marker Cluster
  markerCluster = new MarkerClusterer(map, markersArray, mcOptions);

  if (searchLatLng === '' || searchLatLng === "0") {
    map.fitBounds(bounds);

    map.setCenter(bounds.getCenter());
  }
}


function getMarkerIcon(advertType) {
  switch (location.advertType) {
    case "Large Development":
      markerIcon = imagePinLarge;
      break;
    case "Code Large Development":
      markerIcon = imagePinCodeLarge;
      break;
    case "Unipol Large Development":
      markerIcon = imagePinCodeLargeUnipol;
      break;
    case "Unipol Housing":
      markerIcon = imagePinCodeUnipol;
      break;
    case "Unipol Code":
      markerIcon = imagePinCode;
      break;
    default:
      markerIcon = imagePinStandard;
  }
}


function addMarker(location, i) {
  if (!location)
    return;

  if (location === '')
    return;

  var markerIcon;
  switch (location.advertType) {
    case "Large Development":
      markerIcon = imagePinLarge;
      break;
    case "Code Large Development":
      markerIcon = imagePinCodeLarge;
      break;
    case "Unipol Large Development":
      markerIcon = imagePinCodeLargeUnipol;
      break;
    case "Unipol Housing":
      markerIcon = imagePinCodeUnipol;
      break;
    case "Unipol Code":
      markerIcon = imagePinCode;
      break;
    default:
      markerIcon = imagePinStandard;
  }

  var marker = new google.maps.Marker({
    position: location.latlng,
    icon: markerIcon,
    animation: google.maps.Animation.DROP,
    map: map,
    id: 'marker_' + location.id
  });
  google.maps.event.addListener(marker, 'click', (function () {
    return function () {

      getRelatedAdvertsPopup(marker, location.longLatOriginal, location.advertCount, location.id);

    };
  })(marker, i));

  markersArray.push(marker);
  bounds.extend(location.latlng);
}


function getRelatedAdvertsPopup(mapMarker, longLat, advertCount, advertId) {

  if (longLat === undefined) {
    propertyPanel(advertId);

  } else {
    $.ajax({
      type: 'Post',
      url: '/housing/bylonglat/' + longLat + '/',
      dataType: 'html',
      data: getLatestAccommodationFilters(),
      success: function (data) {
        if (data === "ShowPanel") {
          propertyPanel(advertId);
        } else {
          CloseFilters();
          infowindow.setContent("<p><strong>Adverts</strong>" + data + "");
          infowindow.open(map, mapMarker);
        }
      },
      error: function (xhr, ajaxOptions, error) {
        alert('Error loading advert: ' + xhr.responseText);
      }
    });
  }

}


// Reset the markers icon
function resetMarkers() {
  if (markersArray) {
    for (let i in markersArray) {
      if (typeof markersArray[i] !== 'function') {

        markersArray[i].setAnimation(null);

      }
    }
  }
}


// Removes the overlays from the map, but keeps them in the array
function clearOverlays() {
  if (markersArray) {
    for (let i in markersArray) {
      if (typeof markersArray[i] !== 'function') {
        markersArray[i].setMap(null);
        markerCluster.removeMarker(markersArray[i]);
      }
    }
  }
}


// Shows any overlays currently in the array
function showOverlays() {
  if (markersArray) {
    for (i in markersArray) {
      if (typeof markersArray[i] !== 'function') {
        markersArray[i].setMap(map);
      }
      markerCluster.addMarker(markersArray[i]);
    }
  }
}


// Deletes all markers in the array by removing references to them
function deleteOverlays() {
  if (markersArray) {
    for (let i in markersArray) {
      if (typeof markersArray[i] !== 'function') {
        markersArray[i].setMap(null);
        markerCluster.removeMarker(markersArray[i]);
      }
    }
    markersArray.length = 0;
  }
}


function propertyPanel(advertId) {
  var displayMode = $('#displayMode').val();
  var advertPanel = $('#advert-' + displayMode);

  $(advertPanel).find('#property-list li').removeClass('active');
  $(advertPanel).find('#property-list #' + advertId).addClass('active');

  if ($('#property-list #' + advertId).length > 0) {
    //Scroll to selected
    $('.advert-list-panel').scrollTo($('ul#property-list li.active'), 800);
  }

  if (!$.trim($('#property-panel').html()).length) {
    showLoading();
  }

  $.get('/accommodation/propertypanel/' + advertId, function (data) {

    $('#property-panel').empty().html(data);

    if ($('.displayPropertyBanner').length) {
        carousel();
    }

    loadMap();

    hideLoading();
  })
  .fail(function() {
    hideLoading();
  });

  ShowRoomDetails();

  resetMarkers();
  var markers = jQuery.grep(markersArray, function (marker) {
    // this is a reference to the element in the array
    // you can do any test on it you want
    // return true if you want it to be in the resulting matches array
    // return false if you don't want it to be in the resulting matches array

    // for example: to find objects with the id property set to a certain value
    return marker.id === 'marker_' + advertId;
  });
  // matches contains all objects that matches
  if (markers.length) {
    // first match is in matches[0]
    //markers[0].setIcon(imagePinCode);
    markers[0].setAnimation(google.maps.Animation.BOUNCE);
    markers[0].setZIndex(google.maps.Marker.MAX_ZINDEX + 1);

    map.setZoom(singleItemZoom);
    map.panTo(markers[0].position);
  }

  //Hash URL
  window.location.hash = '';
  window.location = '#advert=' + advertId;

}


function submitBookingForm() {

  var formData = $("#booking-form").serialize();
  showLoading();

  $.ajax({
    url: '/housing/bookingform',
    type: "Post",
    data: formData,
    success: function (data, status, XMLHttpRequest) {
        hideLoading();
        if (data.includes('alert-success')) {
            window.unipolSharedNamespace.sendGTM($("#booking-form")[0]);
        }
      $("#booking-form-container").html(data);
    },
    error: function (XMLHttpRequest, status, error) {
        hideLoading();
        if (error) {
            alert('An Error occurred: #4 ' + error);
        }
    }
  });
}


function resizeMap(map) {
  google.maps.event.trigger(map, 'resize');
  mapResized = true;
}


function getSelectedFilter() {
  var selectedDate = $("#monthpicker-input").data('datepicker');
  var selectedMonth = selectedDate.date.getMonth() + 1;
  var selectedYear = selectedDate.date.getFullYear();

  advertFilter.City = $('#City').val();
  advertFilter.RentFrom = $('#RentFrom').val();
  advertFilter.RentTo = $('#RentTo').val();
  advertFilter.BedroomsFrom = $('#BedroomsFrom').val();
  advertFilter.BedroomsTo = $('#BedroomsTo').val();
  advertFilter.MoveInMonth = selectedMonth;
  advertFilter.MoveInYear = selectedYear;
}


function BindMonthPicker() {

  if (!($('.monthpicker').length)) return;

  $('.monthpicker').datepicker({
    "format": "MM yyyy",
    'startView': 1,
    'minViewMode': 1,
    'pick': function (e) {
      var $this = $(this);

      var dp = $(e.currentTarget).data('datepicker');
      dp.date = e.date;
      dp.setValue();
      dp.hide();

      var realDate = new Date(e.date);
      var formattedDate = realDate.toLocaleString("en", { month: "long" }) + ' ' + realDate.toLocaleString("en", { year: "numeric" });
      var moveInDate = '01/' + realDate.toLocaleString("en", { month: "numeric" }) + '/' + realDate.toLocaleString("en", { year: "numeric" }) + ' 00:00:00';

      setTimeout(function () {
        $this.val(formattedDate);
        $('#MoveInDate').val(moveInDate);
      }, 5);
    }
  });

  $('.monthpicker').keypress(function (e) {
    return false;
  });

  $('.monthpicker').keydown(function (e) {
    if (e.keyCode !== 46 && e.keyCode !== 8)
      return false;

    $(e.currentTarget).val("");
    e.stopPropagation();
    e.preventDefault();
    return false;
  });
}


function updatePropertiesFoundCount() {
  var advertsFound = $('#property-list li');

  $('#properties-found-count').text(advertsFound.length);
}


function searchbyAdvertId() {
  $('#js-page-number').val(1);
  var searchAdvertId = $('#search-advert-id').val();
  if (searchAdvertId !== '') {
    localStorage['lastAdvertId'] = searchAdvertId;

    $('#current-search-id').val('');
    filterAdvertsById(searchAdvertId);
    hideSaveSearchOption();
  }
}


function addToFavourites(advertId) {
  $.post('/housing/addtofavourites/' + advertId, function (data) {
  });
}


function removeFromFavourites(advertId) {
  $.post('/housing/removefromfavourites/' + advertId, function (data) {
  });
}


function saveSearchUser() {
  $.ajax({
    url: '/accommodation/savesearchuser',
    type: "Post",
    data: getLatestAccommodationFilters(),
    success: function (data, status, XMLHttpRequest) {
      _gmapNotification({
            title: 'Search Saved',
            text: 'Your search filters were saved. You can access saved searches in your <a href="/my-unipol">My Unipol</a> area.'
          });
    },
    error: function (XMLHttpRequest, status, error) {
        if (error) {
            alert('An Error occurred: #4 ' + error);
        }
    }
  });
}

function _gmapNotification(options) {
  if (!options) { options = {}; }
  var show = function (el, text) {
      if (text) { el.html(text); el.show(); } else { el.hide(); }
  };

  var title = options.title;
  var text = options.text;
  var dialog = $('#notification-dialog');
  var header = dialog.find('.modal-header');
  var footer = dialog.find('.modal-footer');

  show(dialog.find('.modal-body'), text);
  show(dialog.find('.modal-header h3'), title);
  dialog.modal('show');
}

function showFavourites() {
  var displayMode = $('#displayMode').val();
  var advertPanel = $('#advert-' + displayMode);
  var pageNumber = $('#js-page-number').val();

  showLoading();

  $.ajax({
    url: '/housing/favourites/list/1',
    type: "get",
    success: function (dataList, status, XMLHttpRequest) {

      if (dataList.advertCount === 0) {
        //No Results
        var msg = '';
        msg += '<p>';
        msg += 'There are no adverts matching your choices.';
        msg += '</p>';
        showMessageOverlay(msg);

        bindFilterPanel();

        advertMarkers = null;
        $('#filter-link').text('Results (' + dataList.advertCount + ') +');
        deleteOverlays();
        hideLoading();
      }
      else {
            var hiddenDataPanel = $('#advert-grid');
            if (displayMode === "grid") {
              hiddenDataPanel = $('#advert-list');
            }

            $(hiddenDataPanel).hide().html(dataList.advertListHtml);
            $(hiddenDataPanel).find('#property-list').html(dataList.advertListAdvertsHtml);
            $(advertPanel).hide().html(dataList.advertListHtml).fadeIn('slow', function () {
              $(advertPanel).find('#property-list').html(dataList.advertListAdvertsHtml);
              $('#js-advert-pins').val(JSON.stringify(dataList.advertPins));
              updatePropertiesFoundCount();
              advertMarkers = $.parseJSON($("#js-advert-pins").val());
              reloadAdvertPins();
            });
            $('.js-load-more').hide();

            CloseFilters();

            hideLoading();

            showAdvertResultsPanel();
            hideSaveSearchOption();
      }
    },
    error: function (XMLHttpRequest, status, error) {
        if (error) {
            alert('An Error occurred: #6 ' + error);
        }
    }
  }, 1000);

}


function showSaveSearchOption() {
    $('#btn-save-search').show();
}

function hideSaveSearchOption() {
    $('#btn-save-search').hide();
}

function filterAdverts(formData) {
  $('#js-page-number').val(1);
  showLoading();
  searchBySearchId(formData);
}


function searchBySearchId(formData) {
  var displayMode = $('#displayMode').val();
  var advertPanel = $('#advert-' + displayMode);
  var pageNumber = $('#js-page-number').val();

  // $('#current-search-id').val(currentSearchId);

    $.ajax({
    url: '/accommodation/housing-list/' + pageNumber,
    type: "POST",
    data: formData,
    success: function (dataList, status, XMLHttpRequest) {

      if (dataList.advertCount === 0) {

        //No Results

        var msg = '<h1>Oops...sorry</h1>';
        msg += '<p>';
        msg += 'There are no adverts matching your choices.';
        msg += '</p>';
        showMessageOverlay(msg);

        bindFilterPanel();

        advertMarkers = null; //data.advertPins;
        $('#filter-link span').text('Results (' + dataList.advertCount + ')');
        $('#btn-results').text('Results: ' + dataList.advertCount + ' +');
        $('.js-load-more').html('Load more').hide();

        deleteOverlays();
        hideLoading();

        //Show Message for Embargo Blocked advert if there any
        showEmbargoAdvertsMessage();

        showAdvertResultsPanel();
        hideSaveSearchOption();
      }
      else {
            var hiddenDataPanel = $('#advert-grid');
            if (displayMode === "grid") {
              hiddenDataPanel = $('#advert-list');
            }

            if (dataList.advertCount > pageNumber * advertLimit) {
              $('#js-page-number').val(parseInt(pageNumber) + 1);
            }

            if (pageNumber === "1") { // First time load _AdvertList partial view before injecting the paged list

              $(hiddenDataPanel).hide().html(dataList.advertListHtml);
              $(hiddenDataPanel).find('#property-list').html(dataList.advertListAdvertsHtml);

              $(advertPanel).hide().html(dataList.advertListHtml).fadeIn('slow', function () {
                $(advertPanel).find('#property-list').html(dataList.advertListAdvertsHtml);
                $('#js-advert-pins').val(JSON.stringify(dataList.advertPins));
                updatePropertiesFoundCount();
                advertMarkers = $.parseJSON($("#js-advert-pins").val());
                reloadAdvertPins();
              });
            } else {
              $(hiddenDataPanel).find('#property-list').append(dataList.advertListAdvertsHtml);
              $(advertPanel).find('#property-list').append(dataList.advertListAdvertsHtml);
              $('#js-advert-pins').append(JSON.stringify(dataList.advertPins));
              updatePropertiesFoundCount();
              advertMarkers = $.parseJSON($("#js-advert-pins").val());
              reloadAdvertPins();
            }

            if (dataList.advertCount > advertLimit) {

              if (dataList.advertCount > pageNumber * advertLimit) {
                $('#btn-results').text('Results: showing ' + pageNumber * advertLimit + ' of ' + dataList.advertCount);
                $('.js-load-more').html('Load more').show();
              }
              else {
                $('#btn-results').text('Results: showing ' + dataList.advertCount + ' of ' + dataList.advertCount);
                $('.js-load-more').hide();
              }
            } else {
              $('#btn-results').text('Results: showing ' + dataList.advertCount + ' of ' + dataList.advertCount);
              $('.js-load-more').hide();
            }

            $('#filter-link span').text('Results (' + dataList.advertCount + ') +');

            CloseFilters();

            hideLoading();

            showAdvertResultsPanel();
            showSaveSearchOption();

      }
      var formDataToSave = $('#advert-filters-form').serialize();
      saveLatestAccommodationFilters(formDataToSave);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
          'event': 'search.filters',
          'search_filter_selected': formData.replace(/&__RequestVerificationToken=[^&]*/, '').replaceAll('&', ', '),
          'search_results_advert_count': dataList.advertCount
      });
    },
    error: function (XMLHttpRequest, status, error) {
        if (error) {
            alert('An Error occurred: #9 ' + error);
        }
    }
  }, 500);
}


function showAdvertResultsPanel() {
  //Show Advert Panel with results based on display mode

  toggleListGrid();
}


function toggleListGrid() {
  var displayMode = $('#displayMode').val();
  var advertPanel = $('#advert-' + displayMode);

  if (displayMode === "list") {
    if ($('.list-panel').hasClass('show') === false) {
      $('.list-panel').addClass('show');
    }
    $('.list-panel').show();
    $('.js-price-graph').show();
    $('.grid-panel').removeClass('show');
  }

  if (displayMode === "grid") {
    if ($('.grid-panel').hasClass('show') === false) {
      $('.grid-panel').addClass('show');
    }
    $('.list-panel').hide();
    $('.js-price-graph').hide();
    $('.list-panel').removeClass('show');
  }
}


function filterAdvertsById(advertId) {

  showLoading();

  $.ajax({
    url: '/housing/filter-by-id/' + advertId,
    type: "Get",
    success: function (data, status, XMLHttpRequest) {
      $('#current-search-id').val('');

      if (data.advertCount === 0) {
        //No Results
        var msg = '';
        msg += '<p>';
        msg += 'There are no adverts matching your choices.';
        msg += '</p>';
        showMessageOverlay(msg);

        bindFilterPanel();

        advertMarkers = null;
        $('#filter-link').text('Results (' + data.advertCount + ') +');
        deleteOverlays();
        hideLoading();
      }
      else {
        $('#advert-list').hide().html(data.advertListHtml).fadeIn('slow', function () {
          $('#advert-list').find('#property-list').html(data.advertListAdvertsHtml);
          $('#js-advert-pins').val(JSON.stringify(data.advertPins));
          updatePropertiesFoundCount();
          advertMarkers = $.parseJSON($("#js-advert-pins").val());
          reloadAdvertPins();

          $('#filter-link').text('Results (' + data.advertCount + ') +');

          propertyPanel(advertId);
        });
      }

    },
    error: function (XMLHttpRequest, status, error) {
        if (error) {
            alert('An Error occurred: #10 ' + error);
        }
    }
  }, 1000);

}


function filterRentOnline() {

  showLoading();

  $.ajax({
    url: '/housing/rentonline',
    type: "Get",
    success: function (dataList, status, XMLHttpRequest) {
      if (dataList.advertCount === 0) {
        //No Results
        let msg = '';
        msg += '<p>';
        msg += 'There are no adverts matching your choices.';
        msg += '</p>';
        showMessageOverlay(msg);

        bindFilterPanel();

        advertMarkers = null;
        $('#filter-link').text('Results (' + dataList.advertCount + ') +');
        deleteOverlays();
        hideLoading();
      }
      else {
        $('#advert-list').hide().html(dataList).fadeIn('slow', function () {
          updatePropertiesFoundCount();

          advertMarkers = dataList.advertPins;

          $('#filter-link').text('Results (' + dataList.advertCount + ') +');

          if (dataList.advertCount > advertLimit) {
            showMessageOverlay(advertCountWarning);
          }
          showLoading();
          CloseFilters();
          reloadAdvertPins();
        });
      }
    },
    error: function (XMLHttpRequest, status, error) {}
  }, 1000);
}


function ShowFilters() {
  $('.filters-container').toggleClass('show');
  $('.advert-filters .btn-filter').toggleClass('collapsed');
  CloseRoomDetails();
}


function ShowFiltersMore() {
  $('.filters-more-container').toggle(
    function () {
      $(this).show("slide", { direction: "right" }, 1000);
    }
    ,
    function () {
      $(this).hide("slide", { direction: "right" }, 1000);
    });
  CloseRoomDetails();
}


function CloseRoomDetails() {
  $('.room-panel').removeClass('show');
  $('.room-panel').removeClass('show-grid');
  $('#property-panel').empty();
  $('.map-container').removeClass('nudge'); /* make map larger again */
  resetMarkers();
  window.location.hash = '';
}


function ShowRoomDetails() {
  if ($('#displayMode').val() === "grid") {
    $('.room-panel').removeClass("show");
    $('.room-panel').addClass("show-grid");
  } else {
    $('.room-panel').removeClass("show-grid");
    $('.room-panel').addClass("show");
    $('.map-container').addClass('nudge');
  }

  $('.filters-container').removeClass('show');
}


function HideListMapFull() {
  CloseRoomDetails();
  $(".map-container").addClass("full-width");
}


function bindFilterPanel() {
  setFilterSelections();
}


function CloseFilters() {
  $('.filters-container').removeClass('show');
}


function openBookingPage() {
  $('#mainpage').animate({
    left: '350px'
  }, 400, 'easeOutBack');
}


function closeSidepage() {
  $("#navigation li a").removeClass("open");
  $('#mainpage').animate({
    left: '0px'
  }, 400, 'easeOutQuint');
}


function showWarningOverlay(warningText, warningImage) {
  $('#modal-warning .modal-body').html(warningText);
  if (warningImage !== "") {
    $('#modal-warning .modal-image').attr('src', warningImage);
  }
  $('#modal-warning').modal('show');
}


function showMessageOverlay(messageText) {
  $('#modal-message .modal-body').html(messageText);
  $('#modal-message').modal('show');
}


function showChangedField(theSelector) {
  $(theSelector).addClass('changed').animate({ backgroundColor: '#faaca5' }, 1, function () {
    var $this = $(this);

    setTimeout(function () {
      $this.animate({ backgroundColor: '#fff' }, 1000).promise().done(function () {
        $this.removeClass('changed');
      });
    }, 800);
  });
}


function updateFilterSelections(firstTime) {
  filterSelections.propertyType = $('#PropertyTypeId').val();

  if (firstTime === 'undefined' || firstTime === false) {
    filterSelections.wholeProperty = $('#ddl-whole-property-required').val();
    filterSelections.bedsFrom = $('#BedroomsFrom').val();
    filterSelections.dateMode = $('#DateMode').val();
  }
  bindFilterPanel();
}


function setFilterSelections() {
  $('#PropertyTypeId').val(filterSelections.propertyType);
  $('#ddl-whole-property-required').val(filterSelections.wholeProperty);
  $('#BedroomsFrom').val(filterSelections.bedsFrom);
  if($('#DateMode').val() != 4) $('#DateMode').val(filterSelections.dateMode);
}


function drawChart(returnedData) {
  if (returnedData !== null) {
    var chartDiv = $('#chart_div');
    chartDiv.css("width", $('.price-graph').width() - 300);
    chartDiv.html();

    setTimeout(() => {
        // load the returned price data string array into a Google dataTable
        var data = new google.visualization.DataTable(returnedData);
        var chart = new google.visualization.AreaChart(document.getElementById('chart_div')); //SteppedAreaChart

        try {
        chart.clearChart();

        google.visualization.events.addListener(chart, 'onmouseover', myHandler);

        if (window.innerHeight < 750) {
            $('.price-graph').addClass('small');
            $('.map-container').addClass('small');
            $('.filters-container').css('top', 125);
            chart.draw(data, graphOptionsSmall);
        } else {
            $('.price-graph').removeClass('small');
            $('.map-container').removeClass('small');
            $('.filters-container').css('top', 155);
            chart.draw(data, graphOptions);
        }
        } catch (e) {
        /**catchMe**/
        }
    }, 1000);

  }
}


function myHandler(e) {
  var tooltip = $(".google-visualization-tooltip");
  var offset = tooltip.offset();

  tooltip.zIndex = 128;

  tooltip.offset({ left: offset.left + 90, top: offset.top - 50 });

  if (e.row !== null) {
    if (e.row === 0) {
      tooltip.offset({ left: 535 });
    } else if (e.row === 1) {
      tooltip.offset({ left: 575 });
    } else if (e.row === 2) {
      tooltip.offset({ left: 615 });
    } else if (e.row === 3) {
      tooltip.offset({ left: 655 });
    }
  }
}


function createCustomHTMLContent(price, properties) {
  return '<p>' + price + ' pppw<br />' + properties + (properties === 1 ? ' property' : ' properties') + '</p>';
}

// ***** END FUNCTIONS ********* //



// ***** UI EVENTS *********

// Target Element
$('#DateMode').on('change', function () {
  showMoveInDatePicker();
});


$('.current-filters-container').on('click', function () {
  ShowFilters();
});


$('.btn-close-filters').on('click', function () {
  CloseFilters();
});


$('.current-filters-more-container').on('click', function () {
  ShowFiltersMore();
});


$('#btn-hide-list').on('click', function () {
  HideListMapFull();
});


$(document).on("click", '#btn-advanced-filters', function () {
  $('#filters-basic').fadeOut(function () { $('#filters-advanced').fadeIn(); });
});


$(document).on("click", '#btn-basic-filters', function () {
  $('#filters-advanced').fadeOut(function () { $('#filters-basic').fadeIn(); });
});


//Close room details
$(document).on("click", '.room-details > .close', function () {
  CloseRoomDetails();
});


$(document).on('click', '#footer-bar', function () {
  $('#footer-bar').toggleClass('show');
  $('.footer-show-button img').toggle();
});


$(document).on('click', '#js-bills-inclusive input:checkbox', function () {
  if ($(this).prop("checked") === true) {
    $('.js-bills-inclusive input:checkbox').prop("checked", true);
  }
  else {
    $('.js-bills-inclusive input:checkbox').prop("checked", false);
  }
});

$(document).on("change", '.js-reason-for-contact', (e) => {
    let messages = {
        0: 'Book a Viewing',
        1: 'Property Enquiry'
    };
    let message = $('.js-message-subject').val();
    let startPosition = message.indexOf(':');
    let newMessage = messages[e.currentTarget.selectedIndex] + ' :' + message.slice(startPosition + 1);
    $('.js-message-subject').val(newMessage);
});

//Request a viewing
$(document).on("click", '#btn-request-viewing', function () {
  submitBookingForm();
});


//$(document).on("hidden", '#modal-warning', function () {
//    alert('closed');
//    $(this).toggleClass("show");
//});


//Toggle Mobile List/Map
$(document).on("click", '.btn-mobile-show.map', function () {
  CloseFilters();
  $(".btn-mobile-show list").removeClass("active");
  $(this).addClass("active");

  $(".map-container").addClass("top");
  //$(".list-panel").removeClass('show');
});


$(document).on("click", '.btn-mobile-show.list', function () {
  CloseFilters();
  $(".btn-mobile-show.map").removeClass("active");
  $(this).addClass("active");

  $(".map-container").removeClass("top");
  $(".list-panel").addClass('show');
});


$(document).on("click", '#btn-advert-by-id', function (e) {
  e.preventDefault();
  searchbyAdvertId();
});


$(document).on("submit", '#form-advert-by-id', function (e) {
  e.preventDefault();
  searchbyAdvertId();
});


$(document).on("keydown", '#search-advert-id', function (e) {
  //e.preventDefault();
  if (event.keyCode === 13) {
    searchbyAdvertId();
    return;
  }

  // Allow: backspace, delete, tab, escape, enter and .
  if ($.inArray(event.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
    // Allow: Ctrl+A
    event.keyCode === 65 && event.ctrlKey === true ||
    // Allow: home, end, left, right
    event.keyCode >= 35 && event.keyCode <= 39) {
    // let it happen, don't do anything
    return;
  }
  else {
    // Ensure that it is a number and stop the keypress
    if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
      event.preventDefault();
    }
  }
});


$(document).on("click", '#btn-apply-filter', function (e) {
  e.preventDefault();
  setFiltersAndSubmit();
});


$(document).on("click", '#btn-add-to-favourites', function (e) {
  var btnFav = $('#btn-add-to-favourites');
  var displayMode = $('#displayMode').val();
  var advertPanel = $('#advert-' + displayMode);

  if (btnFav.attr('data-state') === "False") {
    addToFavourites(btnFav.data("id"));
    btnFav.html('Remove From Favourites');
    btnFav.attr("data-state", "True");
    $(advertPanel).find('#' + btnFav.data("id") + ' .property-image').append('<i class="material-icons icon-star-border"></i>');
  } else {
    removeFromFavourites(btnFav.data("id"));
    btnFav.html('Add To Favourites');
    btnFav.attr("data-state", "False");
    $(advertPanel).find('#' + btnFav.data("id") + ' i.material-icons').remove();
  }

  //setFiltersAndSubmit();
});


$(document).on('click', '.field-clear', function (e) {
  var theFieldToClear = $(this).attr('data-field');
  var theValueToSet = $(this).attr('data-field-value');

  $('#' + theFieldToClear).val(theValueToSet);
});


$(document).on("click", '#btn-book-viewing', function (e) {
  var advertId = $(this).data("id");

  $.get('/housing/book/' + advertId, function (data) {
    $('#property-panel').html(data);
  });
});


$(document).on("click", '#btn-back-to-advert', function (e) {
  var advertId = $(this).data("id");

  $.get('/accommodation/propertypanel/' + advertId, function (data) {
    $('#property-panel').html(data);
  });
});


$(document).on("click", '#btn-results', function (e) {
  $('#property-list-nav li').removeClass('active');
  $(this).parent('li').addClass('active');
  var formData = $('#advert-filters-form').serialize();

  filterAdverts(formData);
});


$(document).on("click", '.js-load-more', function () {
  $(this).html(loaderSmall);

  var formData = $('#advert-filters-form').serialize();
  searchBySearchId(formData);
});


$(document).on("click", '#btn-save-search', function (e) {
  e.preventDefault();

  saveSearchUser();
});


$(document).on("click", '#btn-favourites', function (e) {
  e.preventDefault();
  var advertId = $(this).data("id");
  $('#property-list-nav li').removeClass('active');
  $(this).parent('li').addClass('active');

  showFavourites();
});


$(document).on("submit", '#advert-filters-form', function (event) {
  // url-encode the form data
  var formData = $('#advert-filters-form').serialize();

  filterAdverts(formData);

  event.preventDefault();

});


$(document).on("click", "#view-mode-container .btn-icon", function (e) {

  $('#displayMode').val($(this).data("displaymode"));
  toggleListGrid();

  //searchBySearchId($('#current-search-id').val(), $(this).data("displaymode"));

});


$(document).on('click', "#property-list-popup li", function (e) {
  propertyPanel($(this).attr('id'));
});


$(document).on('click', "#property-list li", function (e) {
  propertyPanel($(this).attr('id'));
});


$(document).on('click', "#advert-grid .property", function (e) {
  propertyPanel($(this).data('id'));
});


$(document).on("click", '.house-warning', function () {
  $(this).removeClass('show');
});


$(document).on("click", '.btn-icon.list', function () {
  $('.btn-icon').removeClass('active');
  $(this).addClass('active');
  $('#displayMode').val('list');
});


$(document).on("click", '.btn-icon.grid', function () {
  $('.btn-icon').removeClass('active');
  $(this).addClass('active');
  $('#displayMode').val('grid');
});


$(document).on('change', '#PropertyTypeId, #BedroomsFrom, #ddl-whole-property-required, #DateMode, #MoveInMonthYear', function (e) {
    setTimeout(() => {
      currentCity = $('#City').val();
      var propertyTypeId = $('#PropertyTypeId').val();
      var bedrooms = $('#BedroomsFrom').val();
      $('#BedroomsTo').val(bedrooms);
      var wholeProperty = $('#ddl-whole-property-required').val();
      var dateMode = $('#DateMode').val();
      var moveInMonthYear = $('#MoveInMonthYear').val();

      let changedFilter = {
          name: e.currentTarget.name,
          value: (e.currentTarget.name === 'MoveInMonthYear')  ? $('#MoveInMonthYear').val() : $(e.currentTarget).find('option:selected').text()
      }

      if (changedFilter.name === 'DateMode' && dateMode === "4") {
        return;
      }

      //Get Filter UI Defaults
      setAffiliateUIdefaults(currentCity, propertyTypeId, bedrooms, wholeProperty, dateMode, moveInMonthYear, changedFilter);
    }, 10);
});

$(document).on('change', '#ddl-orderby', function () {
  var orderBy = $(this).val();

  $('#OrderBy').val(orderBy);
  setFiltersAndSubmit();
});

